import { YoApi } from '@yooink/yorestapi/frontend/es/YoApi';

class LocalizationApi extends YoApi {
	async fetchStats () {
		const { data } = await this.axios.get(this.getUrl('stats'));
		return data;
	}

	async uploadNewLocale (file) {
		const formData = new FormData();
		formData.append('locale', file);
		const { data } = await this.axios.put(this.getUrl('import'), formData);
		return data;
	}
}

export default new LocalizationApi({
	endPoint: 'locale'
});
